
import Events from './events';
const data = {};


let timers = [];


function setTimerFunctions(...fns) {
  timers = fns.map(fn => ({ fn, timeout: 0 }));
}

function setTimerTimeouts(...timeouts) {
  timers = timeouts.map((timeout, index) => {
    const timer = timers[index];
    return Object.assign(timer, {timeout});
  });
  resetTimers();
}

function resetTimers() {
  timers = timers.map((timer) => {
    clearTimeout(timer.id);
    return Object.assign(timer, {id: setTimeout(timer.fn, timer.timeout)});
  });
}

function saveLocally(dataToSave, name, lang) {
  data[getDataKey(name, lang)] = dataToSave;
}

function setOnlineStatus(isOnline) {
  saveLocally({'isOnline': isOnline}, 'onlineStatus', 'all');
}

function isOnline() {
  return getStoredData('onlineStatus', 'all').isOnline;
}

function selectLanguage(lang) {
  switchLanguage(lang);

  // Tracks only when user selects language, not when app changes it automatically
  Events.dispatchEvent('language:selection', lang);
}

function switchLanguage(lang){
  saveLocally(lang, 'lang', 'all');
  Events.dispatchEvent('language:change', lang);
}

function getStoredData(name, lang, _default = {}) {
  return data[getDataKey(name, lang)] || _default;
}

function removeStoredData(name, lang) {
  delete data[getDataKey(name, lang)];
}

function getDataKey(name, lang) {
  return name + '-' + lang;
}

function getTranslations(langs) {
  let translations = {};
  for (var i in langs) {
    const translation = 'translations-' + langs[i];
    translations[langs[i]] = data[translation] || {};
  }
  return translations;
}


const goTo = (hash = 'start') => {
  window.location.hash = hash.replace(/^#/, '');
};

export default {
  saveLocally,
  removeStoredData,
  setOnlineStatus,
  getTranslations,
  getStoredData,
  goTo,
  isOnline,
  setTimerTimeouts,
  setTimerFunctions,
  selectLanguage,
  switchLanguage,
  resetTimers
};
